<template>
  <ul class="page-breadcrumb" v-if="isShowBreadcrumb" :class="customClass">
    <li class="item" :class="{'active': item.component === 'Login'}" v-for="(item, index) in arrayBreadcrumb" :key="index">
      <router-link :to="{name: item.component}" v-if="item.component">{{item.label}}</router-link>
      <template v-else>
        <template v-if="item.label">{{item.label}}</template>
        <template v-else>{{ customName }}</template>
      </template>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Breadcrumb',
  props: {
    page: {
      type: String,
      default: 'temp_register'
    },
    customName: {
      type: String,
    },
    customClass: {
      type: String,
    },
    needAuthentication: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    arrayBreadcrumb () {
      return this.$t('breadcrumb')[this.page] || [];
    },
    ...mapGetters({
      userInfo: 'getUserInfo',
    }),
    isShowBreadcrumb () {
      return (this.userInfo && this.userInfo.user_id) || !this.needAuthentication;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/Breadcrumb.vue